import React from 'react'
import { Component, LocaleCode } from '../types/component'
import { getLocalizedText } from '../utils/localization'
import { cn } from '../lib/utils'

interface StatsProps {
  component: Component
  locale: LocaleCode
  storeId: string
  apiUrl: string
  style: React.CSSProperties
}

export function Stats({ component, locale, style }: StatsProps) {
  const config = component.config as any

  const title = getLocalizedText(config.title, locale)
  const subtitle = getLocalizedText(config.subtitle, locale)
  const stats = config.stats || []
  const columns = config.columns || 4

  const gridColsMap = {
    2: 'md:grid-cols-2',
    3: 'md:grid-cols-3',
    4: 'md:grid-cols-4',
  }
  const gridCols = gridColsMap[columns as keyof typeof gridColsMap] || 'md:grid-cols-4'

  return (
    <div style={style} className="w-full">
      <div className="max-w-7xl mx-auto">
        {(title || subtitle) && (
          <div className="text-center mb-12">
            {title && (
              <h2 className="text-3xl font-bold mb-4" style={{ color: style.color }}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className="text-lg opacity-80" style={{ color: style.color }}>
                {subtitle}
              </p>
            )}
          </div>
        )}

        <div className={cn('grid grid-cols-1 gap-8', gridCols)}>
          {stats.map((stat: any, index: number) => (
            <div
              key={index}
              className="text-center p-6 rounded-lg transition-transform hover:scale-105 shadow-md"
              style={{
                backgroundColor: style.backgroundColor === '#ffffff' || !style.backgroundColor ? 'rgba(0,0,0,0.02)' : 'rgba(255,255,255,0.1)',
              }}
            >
              {stat.icon && (
                <div className="text-3xl mb-3">
                  {stat.icon}
                </div>
              )}
              <div className="flex items-baseline justify-center gap-1 mb-2">
                {stat.prefix && (
                  <span className="text-2xl font-semibold" style={{ color: style.color }}>
                    {stat.prefix}
                  </span>
                )}
                <span className="text-5xl font-bold" style={{ color: style.color }}>
                  {stat.value}
                </span>
                {stat.suffix && (
                  <span className="text-2xl font-semibold" style={{ color: style.color }}>
                    {stat.suffix}
                  </span>
                )}
              </div>
              <p className="text-sm opacity-70 uppercase tracking-wider" style={{ color: style.color }}>
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
